<ng-container>
  <div class="ppt-body-content">
    <div class="record-address-section">
      <rep-presentation-dynamic-view-header
        [reportData]="recordData"
        [reportRecordData]="recordData"
        [currentView]="currentView"
        [headerGroups]="headerGroups"
        [templateProjectionMap]="templateProjectionMap"
      ></rep-presentation-dynamic-view-header>
    </div>
    <div class="record-img-attribute-section">
      <div class="record-img-content">
        <rep-presentation-dynamic-view-image
          [reportId]="reportData?.reportId"
          [reportRecordData]="recordData"
          [imageGroups]="imageGroups"
          [currentView]="currentView"
        ></rep-presentation-dynamic-view-image>
      </div>
      <div class="record-attribute-content">
        <div *ngIf="bodyAttributes" class="property-info-section">
          <!-- Entity attributes and values -->
          <ul>
            <li *ngFor="let field of bodyAttributes.fields" [class]="field.class ? field.class : ''">
              <label>{{
                recordData
                  | reportLabelFormatter
                    : {
                        templateId: currentView.templateId,
                        field: field,
                      }
              }}</label>
              <span>{{
                recordData
                  | reportFieldFormatter
                    : {
                        templateId: currentView.templateId,
                        field: field,
                        joinString: true,
                        onlyUrl: false,
                      }
                  | async
              }}</span>
            </li>
          </ul>
        </div>
        <ng-container>
          <div
            class="bottom-section"
            [ngClass]="tableFields?.fields?.length && footerAttributes?.length ? 'inline-bottom-section' : ''"
          >
            <div class="table-section" *ngIf="tableFields">
              <h3 class="table-title" *ngIf="tableFields.tableConfigs?.tableTitle">
                {{ recordData?.data.length }}
                {{ (recordData?.data.length > 0 ? 'template.availabilities' : 'template.availability') | xTranslate }}
              </h3>
              <table aria-hidden="true" class="template-table">
                <thead>
                  <tr>
                    <th scope="col" *ngIf="tableFields.tableConfigs?.actionCol"></th>
                    <ng-container *ngFor="let col of tableFields.fields">
                      <th
                        scope="col"
                        *ngIf="recordData | isFieldVisible: { templateId: currentView.templateId, field: col }"
                        [ngClass]="col.class"
                      >
                        <span>{{ col.label }}</span>
                      </th>
                    </ng-container>

                    <th
                      scope="col"
                      *ngIf="
                        !footerAttributes?.length &&
                        templateProjectionMap &&
                        (templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')
                      "
                    >
                      {{ 'template.reportConfidentiality' | xTranslate }}
                    </th>
                  </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="onReorder($event, recordData)">
                  <ng-container *ngIf="tableData?.length > 0">
                    <tr *ngFor="let data of tableData; let i = index" cdkDrag cdkDragLockAxis="y">
                      <!-- Action buttons -->
                      <td *ngIf="tableFields.tableConfigs?.actionCol" class="actions">
                        <a class="action-element"
                          ><mat-icon
                            class="handle print-hidden"
                            svgIcon="alt-handle-icon"
                            color="y-icon"
                            cdkDragHandle
                          ></mat-icon
                        ></a>
                        <a class="action-element" (click)="removeRecord.emit(data)"
                          ><mat-icon class="green-close" color="y-icon" svgIcon="close-icon-grey"></mat-icon
                        ></a>
                        <!-- TODO: instead of goToRecordDetails() method need to use miq-goes-to-record once feild from BE is available -->
                        <a (click)="goToRecordDetails(data)" class="action-element">
                          <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"> </mat-icon>
                        </a>
                        <strong>{{ i + 1 }}.</strong>
                      </td>

                      <!-- Columns -->
                      <ng-container *ngFor="let col of tableFields.fields; let i = index">
                        <td *ngIf="recordData | isFieldVisible: { templateId: currentView.templateId, field: col }">
                          <span>{{
                            { recordId: null, position: null, edpRecordId: null, confidentiality: null, data: [data] }
                              | reportFieldFormatter
                                : {
                                    templateId: currentView.templateId,
                                    field: col,
                                    joinString: true,
                                    onlyUrl: false,
                                  }
                              | async
                          }}</span>
                        </td>
                      </ng-container>

                      <!-- Confidentiality selector -->
                      <td
                        *ngIf="
                          !footerAttributes?.length &&
                          templateProjectionMap &&
                          (templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')
                        "
                      >
                        <div class="confidentiality-container">
                          <ng-container
                            [ngTemplateOutlet]="
                              templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'
                            "
                            [ngTemplateOutletContext]="{
                              record: data,
                              reportItem: recordData,
                              displayLabel: true,
                              isDataOnly: true,
                            }"
                          ></ng-container>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="tableData?.length === 0">
                      <td [attr.colspan]="tableFields.tableConfigs.colspan" l10nTranslate>template.noData</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="footerAttributes?.length" class="property-info-section">
              <!-- Confidentiality selector -->
              <div
                *ngIf="
                  templateProjectionMap &&
                  (templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')
                "
                class="confidentiality-container"
              >
                <ng-container
                  [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
                  [ngTemplateOutletContext]="{ reportItem: recordData, displayLabel: true }"
                ></ng-container>
              </div>
              <ul>
                <ng-container *ngFor="let field of footerAttributes">
                  <li
                    [class]="field.class ? field.class : ''"
                    *ngIf="recordData | isFieldVisible: { templateId: currentView.templateId, field: field }"
                  >
                    <label>{{ field.label }}</label>
                    <span class="field-value">{{
                      recordData
                        | reportFieldFormatter
                          : {
                              templateId: currentView.templateId,
                              field: field,
                              joinString: true,
                              onlyUrl: false,
                            }
                        | async
                    }}</span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
          <floor-plan
            [reportId]="reportData?.reportId"
            [reportRecordData]="recordData"
            [templateId]="currentView.templateId"
          ></floor-plan>
        </ng-container>
      </div>
    </div>
    <div class="div-disclaimer">
      <span l10nTranslate> recordPPT.primaryImageDisclaimer</span>
    </div>
  </div>
</ng-container>
